module.exports = __webpack_public_path__ + "img/skin-ilearney.7834605.jpg";